<div class="fc-store-information">
    <ng-container>
        <p class="fc-store-information-description">{{ 'SIGNUP.STORE_INFO.DESCRIPTION' | translate }}</p>
    </ng-container>
    <form
        [formGroup]="storeForm"
        name="storeForm"
        role="form"
        (ngSubmit)="submitStore(storeForm)"
        novalidate
        class="fc-store-information-form"
    >
        <div class="fc-store-information-body">
            <div class="fc-store-information-item-wrapper">
                <label for="name"> {{ 'SIGNUP.STORE_INFO.BRANCH_NAME' | translate }}</label>
                <fcp-form-field [isInvalid]="isFieldInvalid(storeForm, 'name')" [width]="'fluid'">
                    <input
                        id="name"
                        fcpInput
                        formControlName="name"
                        [placeholder]="'SIGNUP.STORE_INFO.BRANCH_NAME_PLACEHOLDER' | translate"
                        data-e2e-hook="name"
                    />
                    <span fcpFieldError>{{ 'SIGNUP.STORE_INFO.VALIDATION.BRANCH_NAME' | translate }}</span>
                </fcp-form-field>
            </div>

            <ng-container>
                <div class="fc-store-information-item-wrapper">
                    <label for="address1">{{ 'ADDRESSLINE_1' | translate }}</label>

                    <fcp-form-field [isInvalid]="isFieldInvalid(storeForm, 'address1')" [width]="'fluid'">
                        <input
                            id="address1"
                            fcpInput
                            formControlName="address1"
                            [placeholder]="'SIGNUP.FORM.PLACEHOLDER.ADDRESS1' | translate"
                            data-e2e-hook="address1"
                        />
                        <span fcpFieldError>{{ 'SIGNUP.FORM.VALIDATION.ADDRESS1' | translate }}</span>
                    </fcp-form-field>
                </div>

                <div class="fc-store-information-item-wrapper">
                    <label for="country">{{ 'SIGNUP.FORM.PLACEHOLDER.COUNTRY' | translate }}</label>
                    <fcp-dropdown
                        id="country"
                        class="fc-guest-panel-form-field"
                        [title]="'SIGNUP.FORM.PLACEHOLDER.COUNTRY' | translate"
                        [items]="countries | async"
                        (searchQueryChange)="onSearchQueryChange($event, 'country')"
                        formControlName="country"
                        dataE2eHook="country"
                    ></fcp-dropdown>
                </div>

                <div class="fc-zip-panel-form-group fc-store-information-item-wrapper">
                    <label for="city">
                        {{ 'SIGNUP.FORM.PLACEHOLDER.CITY' | translate }}

                        <fcp-form-field [isInvalid]="isFieldInvalid(storeForm, 'city')" [width]="'fluid'">
                            <input
                                id="city"
                                fcpInput
                                formControlName="city"
                                [placeholder]="'SIGNUP.FORM.PLACEHOLDER.CITY' | translate"
                                data-e2e-hook="city"
                            />
                            <span fcpFieldError>{{ 'SIGNUP.FORM.VALIDATION.CITY' | translate }}</span>
                        </fcp-form-field>
                    </label>

                    <label for="zip"
                        >{{ 'SIGNUP.FORM.PLACEHOLDER.ZIP' | translate }}

                        <fcp-form-field [isInvalid]="isFieldInvalid(storeForm, 'zip')" [width]="'fluid'">
                            <input
                                id="zip"
                                fcpInput
                                formControlName="zip"
                                [placeholder]="'SIGNUP.FORM.PLACEHOLDER.ZIP' | translate"
                                data-e2e-hook="zip-code"
                            />
                            <span fcpFieldError>{{ 'SIGNUP.FORM.VALIDATION.ZIP' | translate }}</span>
                        </fcp-form-field>
                    </label>
                </div>

                <div class="fc-store-information-item-wrapper">
                    <label for="phone">{{ 'SIGNUP.FORM.PLACEHOLDER.PHONE' | translate }}</label>

                    <fcp-form-field [isInvalid]="isFieldInvalid(storeForm, 'phone')" [width]="'fluid'">
                        <input
                            id="phone"
                            type="tel"
                            fcpInput
                            formControlName="phone"
                            [placeholder]="'SIGNUP.FORM.PLACEHOLDER.PHONE' | translate"
                            data-e2e-hook="phone"
                        />
                        <span fcpFieldError>{{ 'SIGNUP.FORM.VALIDATION.PHONE' | translate }}</span>
                    </fcp-form-field>
                </div>

                <div class="fc-store-information-item-wrapper fc-store-information-gln-wrapper">
                    <label>{{ 'MANAGE_STORE.GLN_TITLE' | translate }}</label>
                    <span
                        class="fc-store-information-gln-icon"
                        [matTooltip]="'MANAGE_STORE.GLN_DESCRIPTION' | translate"
                        matTooltipClass="large-tooltip-text"
                    >
                        <i class="fal fa-info-circle"></i>
                    </span>
                </div>

                <div class="fc-store-information-item-wrapper">
                    <fc-clara-gln-form [glnForm]="glnForm" useFCDesignSystemComponents="true"></fc-clara-gln-form>
                </div>
            </ng-container>
        </div>
        <div class="fc-store-information-footer">
            <button
                fcp-outlined-button
                [size]="'large'"
                type="button"
                (click)="backClicked.emit()"
                class="fc-finish-signup-button"
            >
                {{ 'SIGNUP.BUTTONS.PREV' | translate }}
            </button>

            <button fcp-filled-button [size]="'large'" [disabled]="storeForm.invalid" type="submit">
                {{ 'SIGNUP.BUTTONS.REGISTER' | translate }}
            </button>
        </div>
    </form>
</div>
